import { render, staticRenderFns } from "./securityCodeDetail.vue?vue&type=template&id=583b1caa&scoped=true&"
import script from "./securityCodeDetail.vue?vue&type=script&lang=js&"
export * from "./securityCodeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583b1caa",
  null
  
)

export default component.exports